<template>
<vs-card>
  Upload file To:
  <input
    type="file"
    ref="file"
    accept="image/*"
    @change="FileSelect"
  /><br /><br />
  <vs-button
    class="fields center"
    color="primary"
    type="border"
    @click="Upload"
    >Submit</vs-button
  >
</vs-card>
</template>

<script>
export default {
  name: 'Upload',
  data: () => ({

  }),
  methods: {
    FileSelect(event) {
      const file = this.$refs.file.files[0];
      this.file = file;
      console.log(this.file);
    },
    async Upload() {
      const formData = new FormData();
      formData.append("file", this.file);
      formData.append("mapid", this.itemid);
      try {
        await this.$API
          .post("upload", formData)
          .then(() => {
            this.$vs.notify({
              color: "success",
              title: "Upload Success",
              text: "Upload image complete!",
              position: "top-center",
            });
          })
          .catch((err) => {
            this.$vs.notify({
              color: "danger",
              title: "Upload Fail",
              text: "There is something wrong with the upload system",
              position: "top-center",
            });
          });
      } catch (err) {
        // console.log(err);
      }
    },
  },
  mounted() {

  }
}
</script>

<style>

</style>